
import React, { useState } from 'react';
import useServerApi from 'hooks/useServerApi';

const OPTIONS = [
    'ChatGPT, Grok, Gemini, etc',
    'Google Search',
    'X (formerly Twitter)',
    'Facebook',
    'LinkedIn',
    'YouTube video',
    'Trade show or conference',
    'Webinar or online event',
    'Referral (friend/colleague)',
    'Email Outreach',
];

function WhoReferred({ value, onSkip }) {
    const [selected, setSelected] = useState(value || '');
    const [{ post }] = useServerApi();

    const handleSelect = async (option) => {
        setSelected(option);
        try {
            const [success, response] = await post('/rest_endpoints/agents/crud/update_referral', { referred_by: option });
            console.log(response);
            if (success) {
                onSkip();
            } else {
                console.error('Failed to update referral', response);
            }
        } catch (error) {
            console.error('Error updating referral', error);
        }
        onSkip();
    };

    return (
        <div className="flex flex-col items-center w-full">
            <div className="flex flex-col items-center bg-white rounded-2xl shadow-lg px-8 py-10 w-full max-w-md">
                <h2 className="text-3xl font-bold mb-2 text-center">Where did you hear about us?</h2>
                <p className="text-gray-500 mb-6 text-center">Select one option.</p>
                <div className="grid grid-cols-2 gap-4 w-full mb-6">
                    {OPTIONS.map((option) => (
                        <button
                            key={option}
                            type="button"
                            onClick={() => handleSelect(option)}
                            className={`flex items-center w-full px-4 py-3 border rounded-xl text-left transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-purple-400 ${selected === option
                                ? 'border-purple-600 bg-purple-50 text-purple-900 font-semibold'
                                : 'border-gray-200 bg-white text-gray-900'
                                }`}
                        >
                            <span className="mr-3">
                                <span
                                    className={`inline-block w-5 h-5 rounded-full border-2 transition-colors duration-150 ${selected === option
                                        ? 'border-purple-600 bg-purple-600'
                                        : 'border-gray-300 bg-white'
                                        }`}
                                >
                                    {selected === option && (
                                        <span className="block w-3 h-3 m-1 rounded-full bg-white" />
                                    )}
                                </span>
                            </span>
                            {option}
                        </button>
                    ))}
                </div>
                <button
                    type="button"
                    className="w-full py-3 rounded-xl text-gray-700 font-semibold transition-colors duration-150 bg-gray-200 hover:bg-gray-300 cursor-pointer"
                    onClick={onSkip}
                >
                    Skip
                </button>
            </div>
        </div>
    );
}

export default WhoReferred;
